import React from 'react';
import { FadeIn } from './Shared';
export const StatsBar = () => {
  return <div className="bg-navy-800 border-y border-navy-700 py-6" data-id="element-276">
      <div className="max-w-6xl mx-auto px-4" data-id="element-277">
        <FadeIn data-id="element-278">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-navy-700" data-id="element-279">
            <div data-id="element-280">
              <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-281">
                +1.200
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-282">
                familias
              </div>
            </div>
            <div data-id="element-283">
              <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-284">
                5
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-285">
                Tomos
              </div>
            </div>
            <div data-id="element-286">
              <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-287">
                5
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-288">
                Bonos
              </div>
            </div>
            <div data-id="element-289">
              <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-290">
                4.9/5
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-291">
                ⭐⭐⭐⭐⭐
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </div>;
};